import service from '../utils/request.js';

const siteId = process.env.VUE_APP_SITE_ID;


// 获取文章信息
export function API_siteInfoById() {
    let params = {
        siteId: siteId,
    }
    return service.get("/open/site/siteInfoById", { params: params })
}


// 按栏目类型名称获取栏目列表
export function API_sectionListBySectionTypeName(typeName, listCount) {
    let params = {
        siteId: siteId,
        name : typeName,
        pageNo:1,
        pageSize:listCount
    }
    return service.get("/open/site/sectionListBySectionTypeName", { params: params })
}

// 按栏目类型名称获取文章列表
export function API_articlesListBySectionTypeName(typeName, listCount) {
    let params = {
        siteId: siteId,
        name : typeName,
        pageNo:1,
        pageSize:listCount
    }
    return service.get("/open/site/articlesListBySectionTypeName", { params: params })
}

// 产品列表页：栏目ID获取文章列表
export function API_articlesListBySectionId(sectionId, pageNo, pageSize) {
    let params = {
        siteId: siteId,
        sectionId : sectionId,
        pageNo:pageNo,
        pageSize:pageSize
    }
    return service.get("/open/site/articlesListBySectionId", { params: params })
}

// 产品列表页：栏目ID获取文章列表
export function API_articleById(articleId) {
    let params = {
        siteId: siteId,
        articleId : articleId,
    }
    return service.get("/open/site/articleById", { params: params })
}

// 获取用户列表
export function getUserList(params) {
    return service.get('/user/list', { params: params });
}

// 创建用户
export function createUser(data) {
    return service.post('/user/create', data);
}

// 更新用户信息
export function updateUser(id, data) {
    return service.put(`/user/update/${id}`, data);
}

// 消费者登录
export function customerLogin(params) {
    return service.post('/customer/login', { params: params });
}

// 管理者登录
export function managerLogin(params) {
    return service.post('/manager/login', { params: params });
}
